import { Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { Rating } from 'shared/components/rating'
import { UserAvatar } from 'shared/components/user/user_avatar'
import { DEFAULT_RATING, RatingSubViewProps } from '../queries/shared/types'

export function CrewRatingView({
  shift,
  onPressCloseButton,
  onChangeRating,
}: RatingSubViewProps) {
  const styles = useStyles()
  const user = shift?.user

  return (
    <View style={styles.container}>
      <View style={styles.avatar}>
        <UserAvatar user={user} size={'large'} />
      </View>
      <View style={styles.removeButtonContainer}>
        <PressableOpacity
          style={styles.removeButton}
          onPress={onPressCloseButton}
        >
          <Text style={styles.removeButtonText}>X</Text>
        </PressableOpacity>
      </View>
      <Text style={styles.heading}>
        {t('crewRatingTitle', {
          name: `${user?.firstName} ${user?.lastName}`.concat(`'s`),
        })}
      </Text>
      <Text style={styles.shiftCompletionDescription}>
        {t('crewRatingDescription', {
          name: user?.firstName,
          date: shift?.date,
          time: shift?.endTime,
        })}
      </Text>
      <Rating
        count={5}
        defaultRating={DEFAULT_RATING}
        size={25}
        reviews={[]}
        onFinishRating={rating => onChangeRating(rating)}
      />
    </View>
  )
}

const useStyles = makeStyles((theme, darkMode) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    borderTopWidth: 2,
    borderTopColor: theme.colors?.grey2,
  },
  avatar: {
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    transform: [{ translateY: -50 }],
  },
  errorText: {
    textAlign: 'center',
    textAlignVertical: 'center',
    fontWeight: 'bold',
    color: theme.colors?.primary,
  },
  removeButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  removeButton: {
    marginRight: 20,
    marginTop: 10,
    backgroundColor: theme.colors?.grey3,
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  removeButtonText: {
    fontSize: 10,
    fontFamily: font.bold,
    color: theme.colors?.white,
  },
  shiftCompletionDescription: {
    textAlign: 'center',
    fontSize: 16,
    margin: 15,
    fontFamily: font.normal,
    color: theme.colors?.black,
  },
  heading: {
    textAlign: 'center',
    fontSize: 20,
    margin: 15,
    fontFamily: font.bold,
    paddingTop: 10,
    color: theme.colors.black,
  },
}))
